module.exports = __webpack_public_path__ + "static/media/MS-Sans-Serif.73128510.eot";